module.exports = __webpack_public_path__ + "static/media/youtube_ico.5697b624.svg";